import React from 'react';
import { PromoBannerData } from '@model/promo-banner';
import Cookies, { Cookie } from '@model/common/cookie/cookie';
import { PromoBannerComponent } from '@components/common/banner/promo/PromoBannerComponent';

export interface PromoBannerContainerProps {
  path: string;
  promoBanners: Array<PromoBannerData>;
  tripType: string | null;
}

export const PromoBannerContainer = ({ promoBanners, path, tripType }: PromoBannerContainerProps) => {
  const epc = new Cookies().get(Cookie.EPC);

  return <PromoBannerComponent currentPath={path} promoBanners={promoBanners} tripType={tripType} epc={epc} />;
};
